<template>
  <div class="ui very relaxed divided selection list">
    <div
      class="eight column wide item"
      v-for="(mdle, index) in modules"
      v-bind:key="index"
      v-bind:class="{
        hidden:
          (hide_unused &&
            (!mdle.usr_module_suscriptions ||
              !mdle.usr_module_suscriptions.length)) ||
          mdle.setup.parent_modules,
        blue: mdle.usr_module_suscriptions.length > 0,
      }"
    >
      <div
        class="ui basic right floated mini icon labeled button"
        v-if="mdle.usr_module_suscriptions.length > 0"
        v-on:click="deactivate(mdle, index)"
      >
        <i class="red remove icon"></i>
        {{ $t("deactivate") }}
      </div>
      <div
        class="ui basic right floated mini icon labeled button"
        v-if="
          mdle.setup.configure_component &&
            mdle.usr_module_suscriptions.length != 0
        "
        v-on:click="configure(mdle, index)"
      >
        <i class="blue settings icon"></i>
        {{ $t("configure") }}
      </div>
      <div
        class="ui basic right floated mini icon labeled button"
        v-if="mdle.usr_module_suscriptions.length == 0"
        v-on:click="activate(mdle, index)"
      >
        <i class="green laptop medical icon"></i>
        {{ $t("activate") }}
      </div>
      <i
        class="large chess bishop circle middle aligned icon"
        v-bind:class="{ green: mdle.usr_module_suscriptions.length > 0 }"
      ></i>
      <div class="content">
        <a class="header">{{ $t(mdle.setup.name) }}</a>
        <div class="description">{{ mdle.setup.description }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingsModuleManagementListView",
  props: {
    modules: { type: Array },
    hide_unused: { type: Boolean },
  },
  data() {
    return {};
  },
  methods: {
    submodules(module) {
      let subm = this.modules.filter((m) => {
        return (
          m.setup &&
          m.setup.parent_modules &&
          m.setup.parent_modules.includes(module.setup.name)
        );
      });
      return subm;
    },
    deactivate(module) {
      this.$emit("deactivate", module);
    },
    activate(module) {
      this.$emit("activate", module);
    },
    configure(module) {
      this.$emit("configure", module);
    },
  },
};
</script>
